import {
    type DocumentReference,
    onSnapshot,
    type Query,
    type Unsubscribe,
} from "firebase/firestore";

export function listenToQuery<T>(query: Query, listener: (_: T) => void): Unsubscribe {
    return onSnapshot(query, (querySnapshot) => {
        listener(
            querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            })) as unknown as T,
        );
    });
}

export function listenToDocument<T>(
    document: DocumentReference,
    listener: (_: T) => void,
): Unsubscribe {
    return onSnapshot(document, (docSnapshot) => {
        if (!docSnapshot.exists()) return;
        listener({
            ...docSnapshot.data(),
            id: docSnapshot.id,
        } as unknown as T);
    });
}
